/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * This is a validation directive that forces the field value to be a valid credit card number.
 *
 * Bulb has added this directive because the paymentsValidate directive provided by angular-payments clears out any
 * invalid value, forcing the user to reenter the entire value rather than just simply editing what has already been
 * entered, which is not the desired behavior and is not consistent with the rest of the validators.
 *
 * However, the validation function within angular-payments does actually validate correctly, which is why it is used
 * here rather than implementing it anew.
 */
angular.module('bulbApp.validationModule')
.directive('bulbValidationCardNumber', ['_Validate', bulbValidationCardNumber]);

function bulbValidationCardNumber(_Validate) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attr, model){
      // Add the validation function to the collection of validators for the field.
      model.$validators.cardNumber = function(val) {
        return _Validate('card', val, model, scope, attr);
      };

      model.errorCodes = model.errorCodes || {};

      // Specify the error code for this validator
      model.errorCodes.cardNumber = 'validation_error_credit_card_number';
    }
  };
}
